import React from 'react'
import styled from '@emotion/styled'
import { Container } from 'components/layout/Container/Container'
import { colors, mediaQueriesByDevice, ROUTES } from 'parameters/index'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ArticleSection } from 'experiences/shared/ArticleSection'
import { truncArray } from 'lib'
import { Asset } from 'services/ContentfulService/models/asset'
import { Box, Split, Stack } from 'components/layout/primitives'
import { Heading, ifMobileScreen, Opacity, Paragraph } from 'components/styles'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { PositionMods } from 'components/styles/primitives/modifiers/position/positions'
import { Breadcrumbs } from 'components/elements/Breadcrumbs'
import { ApprovabilityCopy } from '../Approvability/constants'
import { SpaceMultiple, SpaceProperties } from 'components/styles/definitions/size/typographyScale'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import { css } from '@emotion/react'
import { AdvertiserDisclosure } from 'components/content'

interface Props {
	title: string
	introduction: JSX.Element
	graphic?: Asset
	articles: Array<ArticleSummary>
}
export const ToolPageTemplate: React.FC<React.PropsWithChildren<Props>> = ({
	graphic,
	articles,
	children,
	introduction,
	title
}) => {
	return (
		<>
			<Purple>
				<Container modifiers={[PositionMods.Relative, SizeMods({ maxWidth: '1000px' })]}>
					<Stack space="small">
						<Split>
							<Breadcrumbs breadcrumbs={[{ name: 'Learn', url: '/learn' }]} />
							<AdvertiserDisclosure />
						</Split>
						<Heading.H1>{title}</Heading.H1>
						<Text>{introduction}</Text>
						{graphic && (
							<Box
								width="30%"
								modifiers={[
									Opacity(0.3),
									ifMobileScreen(Opacity(0)),
									css({ transform: 'scale(-1,1)', zIndex: 0, bottom: 0, position: 'absolute', right: 0 })
								]}
							>
								<InlineSvg src={graphic?.url} />
							</Box>
						)}
					</Stack>
					<Box height={SpaceMultiple(5)} />
				</Container>
			</Purple>
			<Container>
				<Content>
					<CalculatorWrapper>{children}</CalculatorWrapper>
					<Paragraph small>{ApprovabilityCopy.Legal}</Paragraph>
				</Content>
				<ContentWrapper>
					<ArticleSection
						title="Related Articles"
						articles={truncArray(articles, 4)}
						linkTo={ROUTES.LEARN_ARTICLES}
						isSmallCard
					/>
				</ContentWrapper>
			</Container>
		</>
	)
}

const Purple = styled.div`
	background-color: ${colors.secondaryPurple2};
	width: 100%;
`

const CalculatorWrapper = styled.div`
	position: relative;
	background-color: ${colors.white};
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	margin-bottom: ${SpaceProperties.Big};
`

const Text = styled.span`
	z-index: 2;
	width: 80%;
	a {
		color: ${colors.secondaryPurple1};
	}
	${mediaQueriesByDevice.tablet} {
		width: 100%;
	}
`

const Content = styled.div`
	position: relative;
	top: ${SpaceMultiple(-6)};
	max-width: 750px;

	margin: 0 auto;
	margin-bottom: 84px;
`

const ContentWrapper = styled.div`
	margin-bottom: 64px;
`
